// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeUnitCard_home-unit-card__AAWIb {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s;
}
.HomeUnitCard_home-unit-card__AAWIb:hover {
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  transform: translateY(-4px);
}
.HomeUnitCard_home-unit-card__AAWIb:hover .HomeUnitCard_home-unit-card--info--text--title__yY7G2 {
  text-decoration: underline;
}
.HomeUnitCard_home-unit-card--wrapper__QvUyg {
  width: 100%;
  height: 100%;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--background-cover__vjDql {
  display: flex;
  height: 150px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  overflow: hidden;
  border-bottom: 1px solid var(--accent-color-light);
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--background-cover--image__ugZnK {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--background-cover--level__WKojx {
  display: flex;
  padding: 8px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0px;
  top: 17px;
  border-radius: 12px 0px 0px 12px;
  background: var(--accent-color-medium);
  color: var(--accent-color-light);
  font-size: 12px;
  font-weight: 700;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info__R-bp2 {
  display: flex;
  padding: 62px 24px 12px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  flex: 1 1;
  background: var(--accent-color-light);
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--text__WRZjO {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--text--title__yY7G2 {
  align-self: stretch;
  color: var(--accent-color);
  text-align: center;
  font-size: 20px;
  font-weight: 700;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--text--title__yY7G2.HomeUnitCard_long-text__9xPbe {
  font-size: 16px;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--text--subtitle__hoDwL {
  align-self: stretch;
  color: var(--text-1);
  text-align: center;
  font-size: 14px;
  font-weight: 700;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--statistics--item__EUUER {
  display: flex;
  gap: 8px;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--statistics--item__EUUER svg {
  width: 14px;
  height: 14px;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--statistics--item__EUUER svg path {
  stroke: var(--accent-color);
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--statistics--item__EUUER svg line {
  stroke: var(--accent-color);
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--statistics--item__EUUER p {
  color: var(--text-1);
  font-size: 12px;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--statistics--item__EUUER p span {
  font-weight: 700;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--keywords__2mIqv {
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--info--keywords--item__Aq6VB {
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--accent-color-medium);
  color: var(--accent-color-light);
  font-size: 14px;
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--avatar__8CjFa {
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 50px;
  border-radius: 9999px;
  overflow: hidden;
  border: 1px solid var(--accent-color-light);
}
.HomeUnitCard_home-unit-card__AAWIb .HomeUnitCard_home-unit-card--avatar--image__XzeqG {
  width: 150px;
  height: 150px;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeUnit/HomeUnitCard/HomeUnitCard.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AACF;AACE;EACE,yCAAA;EACA,2BAAA;AACJ;AACI;EACE,0BAAA;AACN;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AAGI;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kDAAA;AADN;AAEM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAAR;AAGM;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;EACA,sCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AADR;AAKI;EACE,aAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,qCAAA;AAHN;AAKM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAHR;AAKQ;EACE,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAHV;AAKU;EACE,eAAA;AAHZ;AAOQ;EACE,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AALV;AAUQ;EACE,aAAA;EACA,QAAA;AARV;AAUU;EACE,WAAA;EACA,YAAA;AARZ;AASY;EACE,2BAAA;AAPd;AASY;EACE,2BAAA;AAPd;AAWU;EACE,oBAAA;EACA,eAAA;AATZ;AAWY;EACE,gBAAA;AATd;AAeM;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAbR;AAeQ;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,sCAAA;EACA,gCAAA;EACA,eAAA;AAbV;AAkBI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;AAhBN;AAkBM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAhBR","sourcesContent":[".home-unit-card {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);\n    transform: translateY(-4px);\n\n    .home-unit-card--info--text--title {\n      text-decoration: underline;\n    }\n  }\n  &--wrapper {\n    width: 100%;\n    height: 100%;\n  }\n  .home-unit-card {\n    &--background-cover {\n      display: flex;\n      height: 150px;\n      justify-content: center;\n      align-items: center;\n      align-self: stretch;\n      overflow: hidden;\n      border-bottom: 1px solid var(--accent-color-light);\n      &--image {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      &--level {\n        display: flex;\n        padding: 8px 24px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        right: 0px;\n        top: 17px;\n        border-radius: 12px 0px 0px 12px;\n        background: var(--accent-color-medium);\n        color: var(--accent-color-light);\n        font-size: 12px;\n        font-weight: 700;\n      }\n    }\n\n    &--info {\n      display: flex;\n      padding: 62px 24px 12px 24px;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 24px;\n      align-self: stretch;\n      flex: 1;\n      background: var(--accent-color-light);\n\n      &--text {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 4px;\n        align-self: stretch;\n\n        &--title {\n          align-self: stretch;\n          color: var(--accent-color);\n          text-align: center;\n          font-size: 20px;\n          font-weight: 700;\n\n          &.long-text {\n            font-size: 16px;\n          }\n        }\n\n        &--subtitle {\n          align-self: stretch;\n          color: var(--text-1);\n          text-align: center;\n          font-size: 14px;\n          font-weight: 700;\n        }\n      }\n\n      &--statistics {\n        &--item {\n          display: flex;\n          gap: 8px;\n\n          svg {\n            width: 14px;\n            height: 14px;\n            path {\n              stroke: var(--accent-color);\n            }\n            line {\n              stroke: var(--accent-color);\n            }\n          }\n\n          p {\n            color: var(--text-1);\n            font-size: 12px;\n\n            span {\n              font-weight: 700;\n            }\n          }\n        }\n      }\n\n      &--keywords {\n        margin-top: auto;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        align-content: center;\n        gap: 8px;\n        align-self: stretch;\n        flex-wrap: wrap;\n\n        &--item {\n          display: flex;\n          padding: 8px;\n          align-items: center;\n          gap: 8px;\n          border-radius: 8px;\n          background: var(--accent-color-medium);\n          color: var(--accent-color-light);\n          font-size: 14px;\n        }\n      }\n    }\n\n    &--avatar {\n      display: flex;\n      align-items: center;\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      top: 50px;\n      border-radius: 9999px;\n      overflow: hidden;\n      border: 1px solid var(--accent-color-light);\n\n      &--image {\n        width: 150px;\n        height: 150px;\n        background-color: #fff;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-unit-card": `HomeUnitCard_home-unit-card__AAWIb`,
	"home-unit-card--info--text--title": `HomeUnitCard_home-unit-card--info--text--title__yY7G2`,
	"home-unit-card--wrapper": `HomeUnitCard_home-unit-card--wrapper__QvUyg`,
	"home-unit-card--background-cover": `HomeUnitCard_home-unit-card--background-cover__vjDql`,
	"home-unit-card--background-cover--image": `HomeUnitCard_home-unit-card--background-cover--image__ugZnK`,
	"home-unit-card--background-cover--level": `HomeUnitCard_home-unit-card--background-cover--level__WKojx`,
	"home-unit-card--info": `HomeUnitCard_home-unit-card--info__R-bp2`,
	"home-unit-card--info--text": `HomeUnitCard_home-unit-card--info--text__WRZjO`,
	"long-text": `HomeUnitCard_long-text__9xPbe`,
	"home-unit-card--info--text--subtitle": `HomeUnitCard_home-unit-card--info--text--subtitle__hoDwL`,
	"home-unit-card--info--statistics--item": `HomeUnitCard_home-unit-card--info--statistics--item__EUUER`,
	"home-unit-card--info--keywords": `HomeUnitCard_home-unit-card--info--keywords__2mIqv`,
	"home-unit-card--info--keywords--item": `HomeUnitCard_home-unit-card--info--keywords--item__Aq6VB`,
	"home-unit-card--avatar": `HomeUnitCard_home-unit-card--avatar__8CjFa`,
	"home-unit-card--avatar--image": `HomeUnitCard_home-unit-card--avatar--image__XzeqG`
};
export default ___CSS_LOADER_EXPORT___;
